/* eslint-disable indent */
import { STATE } from './constants'

export const initialState = {
  scroll: false,
}

export const reducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case STATE:
      return { ...state, scroll: payload }
    default:
      return state
  }
}
